import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Tabs } from 'antd'
import moment from 'moment'
import WorkoutSetsTab from './tabs/workoutSetsTab'
import FormResultsTab from './tabs/formResultsTab'

// Fixed-height, scrollable area for the tab content so the Bridge section
// keeps a compact height and does not stretch the full page.
const ScrollTabs = styled.div`
  .ant-tabs {
    display: flex;
    flex-direction: column;
  }
      .ant-tabs-content-holder {
    overflow-y: auto;
    max-height: 420px;
    padding-right: 4px;
    margin-bottom: 24px;
  }
`

export default function BridgeTables({ personId, startDate, endDate }) {
  // Keep a stable date range reference so the bridge list fetch is not
  // re-triggered on every parent re-render (e.g. when other sections finish
  // loading). Compare by formatted date values so new moment objects for the
  // same week do not cause a refetch.
  const startKey = startDate ? moment(startDate).format('YYYY-MM-DD') : null
  const endKey = endDate ? moment(endDate).format('YYYY-MM-DD') : null

  const dateRange = useMemo(
    () => [
      startKey ? moment(startKey) : moment().subtract(7, 'days'),
      endKey ? moment(endKey) : moment()
    ],
    [startKey, endKey]
  )

  const startDateStr = dateRange[0].format('MMM DD, YYYY')
  const endDateStr = dateRange[1].format('MMM DD, YYYY')

  return (
    <div style={{ marginTop: 32 }}>
      <div style={{ marginBottom: 16 }}>
        <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 4 }}>Bridge</h3>
        <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 12 }}>
          Bridge syncs workout activity and movement analysis from connected training
          devices for the selected period ({startDateStr} – {endDateStr}). Review
          completed workout sets and form quality results captured during each session.
        </p>
      </div>
      <ScrollTabs>
        <Tabs defaultActiveKey="workoutsets">
          <Tabs.TabPane tab="Workout Sets" key="workoutsets">
            <WorkoutSetsTab personId={personId} dateRange={dateRange} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Form Results" key="formresults">
            <FormResultsTab personId={personId} dateRange={dateRange} />
          </Tabs.TabPane>
        </Tabs>
      </ScrollTabs>
    </div>
  )
}
